<ng-container *ngIf="!isLoading">
    
  <div>
    <div class="container" id="print-section1">
      <table class="table table-bordered">
        <thead>


             <tr>
            <th [attr.colspan]="totalth - 0" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - तालुकानुसार प्रतिनिधी 
               <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country"> |<strong>देश:</strong>  {{ appliedFilters.country }}</span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->

                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>	 

                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

          <tr>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
              देश</th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
              राज्य</th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
              जिल्हा</th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
              तालुका</th>
          
            <th colspan="4"
              style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">
              एकूण</th>
            <ng-container *ngFor="let subtype of subTypesName">
              <th *ngIf="subtype.isVisible" colspan="4"
                style=" border-left: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black; font-size: 13px;">
                {{ subtype.name }}</th>
            </ng-container>
          </tr>

        
    <ng-container *ngFor="let country of finalData; let firstIndex = first; let lastIndex = last">
  <!-- Table Header Row (Only on the First Iteration) -->
  <tr style="text-align: right;" *ngIf="firstIndex">
    <th colspan="4" style="border-left: 2px solid black; border-right: 2px solid black; border-bottom: 1px solid black;"></th>
    <th style=" border-bottom: 2px solid black; border-right: 1px solid black; font-size: 12px;">वर्गणीदार संख्या </th>
    <th style=" border-bottom: 2px solid black; border-right: 1px solid black; font-size: 12px;">रक्कम </th>
    <th style=" border-bottom: 2px solid black; border-right: 1px solid black; font-size: 12px;">नवीन</th>
    <th style=" border-bottom: 2px solid black; border-right: 2px solid black; font-size: 12px;">नूतनीकरण</th>
    <ng-container *ngFor="let data of subTypesName">
      <th *ngIf="data.isVisible" style=" border-left: 2px solid black; border-bottom: 2px solid black; border-right: 1px solid black; font-size: 12px;">नवीन</th>
      <th *ngIf="data.isVisible" style=" border-right: 1px solid black; border-bottom: 2px solid black; font-size: 12px;">नूतनीकरण</th>
      <th *ngIf="data.isVisible" style=" border-right: 1px solid black; border-bottom: 2px solid black; font-size: 12px;">एकूण</th>
      <th *ngIf="data.isVisible" style=" border-right: 2px solid black; border-bottom: 2px solid black; font-size: 12px;">रक्कम</th>
    </ng-container>
  </tr>

  <!-- Country-Level Data -->
  <ng-container *ngIf="country.key !== 'finalData'">
    <tr>
      <th colspan="1"
        style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 12px; word-wrap: break-word; border-bottom: 2px solid black; border-right: 2px solid black;">
        {{ country.key }}
      </th>
      <th colspan="2" style="border-right: 1px solid black; border-bottom: 1px solid black;"></th>
      <th colspan="1" style="border-right: 2px solid black; border-bottom: 1px solid black;"></th>
      <ng-container *ngFor="let sub of subTypesName">
        <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
      </ng-container>
      <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
      <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
      <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
      <td colspan="1" style="border-bottom: 1px solid black; border-right: 2px solid black;"></td>
    </tr>

    <!-- State-Level Data -->
    <ng-container *ngFor="let state of country.value | keyvalue">
      <tr>
        <th colspan="1" style="border-left: 2px solid black; border-bottom: 1px solid black; border-top: 1px solid black; border-right: 1px solid black;"></th>
        <th colspan="1" style="border-left: 2px solid black; border-top: 2px solid black; font-size: 12px; font-weight: bold; word-wrap: break-word; border-bottom: 2px solid black; border-right: 1px solid black;">
          {{ state.key }}
        </th>
        <th colspan="1" style="border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;"></th>
        <th colspan="1" style="border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;"></th>
        <ng-container *ngFor="let sub of subTypesName">
          <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
        </ng-container>
        <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
        <td colspan="1" style="border-bottom: 1px solid black; border-right: 2px solid black;"></td>
      </tr>

      <!-- District-Level Data -->
      <ng-container *ngFor="let district of state.value | keyvalue">
        <tr>
          <th colspan="1" style="font-weight: bold; border-left: 2px solid black; border-bottom: 1px solid black;"></th>
          <th colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></th>
          <th colspan="1"
            style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 12px; word-wrap: break-word; border-bottom: 2px solid black; border-right: 1px solid black;">
            {{ district.key }}
          </th>
          <th colspan="1" style="border-right: 2px solid black; border-top: 2px solid black;"></th>
          <ng-container *ngFor="let sub of subTypesName">
            <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
          </ng-container>
          <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
          <td colspan="1" style="border-bottom: 1px solid black; border-right: 2px solid black;"></td>
        </tr>

        <!-- Taluka-Level Data -->
        <ng-container *ngFor="let taluka of district.value.talukas | keyvalue">
          <tr>
            <th colspan="2" style="font-weight: bold; border-left: 2px solid black; border-bottom: 1px solid black;"></th>
            <th colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></th>
            <th colspan="1"
              style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; font-size: 12px; word-wrap: break-word; border-bottom: 2px solid black; border-right: 2px solid black;">
              {{ taluka.key }}
            </th>
            <ng-container *ngFor="let sub of subTypesName">
              <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
              <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
              <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;"></td>
              <td *ngIf="sub.isVisible" colspan="1" style="border-top: 1px solid black; border-bottom: 1px solid black; border-right: 2px solid black;"></td>
            </ng-container>
            <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td colspan="1" style="border-bottom: 1px solid black; border-right: 1px solid black;"></td>
            <td colspan="1" style="border-bottom: 1px solid black; border-right: 2px solid black;"></td>
          </tr>

          <!-- Representatives -->
          <ng-container *ngFor="let rep of taluka.value.representatives | keyvalue">
            <tr>
              <td style="font-weight: bold; border: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{ rep.key }} - {{ rep.value.rep_taluka }}
              </td>
              <td style="border: 1px solid black;"></td>
              <td style="border: 1px solid black;"></td>
              <td colspan="1" style="border: 1px solid black;"></td>
              <td colspan="1" style="text-align: right; border: 1px solid black; border-left: 2px solid black;">
                {{ (rep.value.new_count || 0) + (rep.value.renew_count || 0) }}
              </td>
              <td colspan="1" style="text-align: right; border: 1px solid black;">
                {{ rep.value.total_amt }}
              </td>
              <td style="text-align: right; border: 1px solid black;">
                {{ rep.value.new_count }}
              </td>
              <td style="text-align: right; border: 1px solid black; border-right: 2px solid black;">
                {{ rep.value.renew_count }}
              </td>
              <ng-container *ngFor="let sub of subTypesName">
                <ng-container *ngIf="sub.isVisible">
                  <td style="text-align: right; border: 1px solid black;">
                    {{ rep.value[getKey(sub.name) + '_नवीन'] || 0 }}
                  </td>
                  <td style="text-align: right; border: 1px solid black;">
                    {{ rep.value[getKey(sub.name) + '_नूतनीकरण'] || 0 }}
                  </td>
                  <td style="text-align: right; border: 1px solid black;">
                    {{ (rep.value[getKey(sub.name) + '_नवीन'] || 0) + (rep.value[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                  </td>
                  <td style="text-align: right; border: 1px solid black; border-right: 2px solid black;">
                    {{ rep.value[getKey(sub.name) + '_एकूण'] || 0 }}
                  </td>
                </ng-container>
              </ng-container>
            </tr>
          </ng-container>

          <!-- Taluka Total Row -->
          <tr class="total-row">
            <td colspan="4"
              style="text-align: right; font-weight: bold; border: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ taluka.key }} - एकूण :-
            </td>
            <td style="text-align: right; border: 1px solid black; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ (taluka.value.finalData['नवीन'] || 0) + (taluka.value.finalData['नूतनीकरण'] || 0) }}
            </td>

            <td style="text-align: right; border: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ taluka.value.finalData['एकूण'] }}
            </td>
            <td style="text-align: right; border: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ taluka.value.finalData['नवीन'] }}
            </td>
            <td style="text-align: right; border: 1px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{ taluka.value.finalData['नूतनीकरण'] }}
            </td>
            <ng-container *ngFor="let sub of subTypesName">
              <ng-container *ngIf="sub.isVisible">
                <td style="text-align: right; border: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                  {{ taluka.value.finalData[getKey(sub.name) + '_नवीन'] }}
                </td>
                <td style="text-align: right; border: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                  {{ taluka.value.finalData[getKey(sub.name) + '_नूतनीकरण'] }}
                </td>
                <td style="text-align: right; border: 1px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                  {{ (taluka.value.finalData[getKey(sub.name) + '_नवीन'] || 0) + (taluka.value.finalData[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
                </td>

                <td style="text-align: right; border: 1px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
                  {{ taluka.value.finalData[getKey(sub.name) + '_एकूण'] }}
                </td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>

        <!-- District Total Row -->
        <tr class="total-row">
          <td colspan="4"
            style="text-align: right; font-weight: bold; border-right: 2px solid black; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ district.key }} - एकूण :-
          </td>
          <td
            style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ (district.value.finalData['नवीन'] || 0) + (district.value.finalData['नूतनीकरण'] || 0) }}
          </td>

          <td style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ district.value.finalData['एकूण'] }}
          </td>
          <td style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ district.value.finalData['नवीन'] }}
          </td>
          <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ district.value.finalData['नूतनीकरण'] }}
          </td>
          <ng-container *ngFor="let sub of subTypesName">
            <ng-container *ngIf="sub.isVisible">
              <td style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                {{ district.value.finalData[getKey(sub.name) + '_नवीन'] }}
              </td>
              <td style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                {{ district.value.finalData[getKey(sub.name) + '_नूतनीकरण'] }}
              </td>
              <td
                style="text-align: right; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                {{ (district.value.finalData[getKey(sub.name) + '_नवीन'] || 0) + (district.value.finalData[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
              </td>

              <td style="text-align: right; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
                {{ district.value.finalData[getKey(sub.name) + '_एकूण'] }}
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Final Global Total -->
  <ng-container *ngIf="country.key === 'finalData'">
    <tr class="total-row">
      <td colspan="4" style="text-align: center; font-weight: bold; border-right: 2px solid black; border-left: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">एकूण :-</td>
      <td
        style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
        {{ (country.value['नवीन'] || 0) + (country.value['नूतनीकरण'] || 0) }}
      </td>

      <td style="text-align: right; font-weight: bold; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
        {{ country.value['एकूण'] }}
      </td>
      <td style="text-align: right; font-weight: bold; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
        {{ country.value['नवीन'] }}
      </td>
      <td style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
        {{ country.value['नूतनीकरण'] }}
      </td>
      <ng-container *ngFor="let sub of subTypesName">
        <ng-container *ngIf="sub.isVisible">
          <td style="text-align: right; font-weight: bold; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ country.value[getKey(sub.name) + '_नवीन'] }}
          </td>
          <td style="text-align: right; font-weight: bold; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ country.value[getKey(sub.name) + '_नूतनीकरण'] }}
          </td>
          <td
            style="text-align: right; font-weight: bold; border-right: 1px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ (country.value[getKey(sub.name) + '_नवीन'] || 0) + (country.value[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
          </td>

          <td style="text-align: right; font-weight: bold; border-right: 2px solid black; border-bottom: 2px solid black; border-top: 2px solid black;">
            {{ country.value[getKey(sub.name) + '_एकूण'] }}
          </td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-container>
</ng-container>

        </thead> 
        <tbody>
          <table>
            <tbody>
           
            </tbody>
          </table>
          
          
          
        </tbody>
       </table> 
     </div> 
  </div>

  <div style="text-align: center; padding-right: 38%;">
      <div style="margin-left: 70%; margin-bottom: 2%;">
        
        <button class="noPrint" style="margin-top: 2% 2% 0 2%;" (click)="exportExcel('Taluka Reprensentative_Subscription_Business_Report')"
          mat-raised-button color="primary">
          Export
        </button>
     

        <button class="noPrint"
      style="margin-top: 2%; margin-left: 2%"
      mat-raised-button color="primary"
      (click)="printPage()">
       Print
     </button>
     
        <button mat-dialog-close class="btn noPrint">
          Close
        </button>
      </div>
    </div>

</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>